import { QueryModel } from './query.model';

export class PdfQueryV1Model extends QueryModel {
  public type = 'com.rbinternational.merlin.smeon.query.pdf.PdfQueryV1';
  public documentId: string;
}
